import React from 'react';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import strapiDb from '../../data/strapi_db.json';
import { StaticImage } from 'gatsby-plugin-image';
// import img from "../../images/holi-2024/Left.png;"
import { useLocation } from '@reach/router';
import { EPpcRoutes } from '@src/constants/routes/index';

const UrgencyTopStrip = () => {
  const { count } = strapiDb?.seatsLeft || { count: 150 };
  const location = useLocation();
  const isFullStackPpcVl = location.pathname.includes(
    EPpcRoutes.FULL_STACK_PPC_ADS_VL,
  );

  return (
    <LeadGenerationButton
      buttonLocation="URGENCY_TOP_STRIP"
      formHeading={'Book your Slot'}
      pageOneButtonText={'Register Now'}
      pageTwoButtonText={'Register Now'}
      type={'HiddenButton'}
      isFullStackPpcVl={isFullStackPpcVl}
    >
      <div
        className={
          'flex min-h-[44px] w-screen cursor-pointer items-center justify-between bg-[#2DF8C5] pl-4 pr-0  font-rubik text-[12px] text-[#013437] md:items-center md:justify-between md:gap-6 md:px-0 md:py-0 md:text-center md:text-[18px]'
        }
      >
        {' '}
        <StaticImage
          src="../../images/3YAnniversary/Left.png"
          className=" hidden h-[60px] max-w-[110px]  md:block md:h-[54px] xl:h-[44px]"
        />
        <div class=" w-full text-center ">
          <div className="text-center">
            Celebrating 5 years of Crio! Avail benefits&nbsp;upto
            <strong>&nbsp;₹1,20,000</strong>&nbsp;|
            <br class="block md:hidden" />
            &nbsp;<strong>{count} seats left </strong>&nbsp;| &nbsp;
            <strong className="underline">Apply Now</strong>{' '}
          </div>
        </div>
        <StaticImage
          src="../../images/3YAnniversary/Right.png"
          className="md:min-w-auto hidden h-[60px] min-w-[110px]  max-w-[110px] md:block md:h-[54px] lg:self-stretch xl:h-[44px]"
        />
      </div>
    </LeadGenerationButton>
  );
};

/*
"Unlock your career potential in 2024 & avail exclusive benefits up to ₹1,20,000 | <> Seats Left"
*/
export default UrgencyTopStrip;
